/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 600px;
`;
export const Content = styled.div`
  background: #fff;
  width: 100%;
`;

export const Group = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Row = styled.div`
  &:hover {
    background: ${Palette.PrimaryGray._100};
  }
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: center;
  padding-left: 24px;
  width: 100%;
  height: 36px;
  cursor: pointer;
`;

const highlightStyle = css`
  & strong {
    color: ${Palette.Primary._500};
    font-weight: inherit;
  }
`;

export const GroupName = styled.label`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${Palette.PrimaryGray._700};
  ${highlightStyle}
  margin-left: 8px;
  cursor: pointer;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
`;
